var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { PeekAutocomplete, PeekInput } from "@piiqtechnologies/ui-components";
import { useError, useLoader, useMagicButtonTemplates } from "@piiqtechnologies/ui-lib";
import React, { useEffect, useMemo, useState } from "react";
const groupByVendorName = (array) => {
    return array.reduce((groups, item) => {
        const { vendorName } = item;
        if (!groups[vendorName]) {
            groups[vendorName] = [];
        }
        groups[vendorName].push(item);
        return groups;
    }, {});
};
export function MagicButtonVendorSelector(_a) {
    var { form, field } = _a, props = __rest(_a, ["form", "field"]);
    const [searchKey, setSearchKey] = useState();
    const [getTemplates, templates, templatesLoading, templatesError] = useMagicButtonTemplates();
    const { setLoader } = useLoader();
    const { setError } = useError();
    useEffect(() => {
        getTemplates({
            limit: 1000,
        });
    }, []);
    useEffect(() => {
        setLoader(templatesLoading, "templatesLoading");
        return () => setLoader(false, "templatesLoading");
    }, [templatesLoading]);
    useEffect(() => {
        if (templatesError)
            setError(templatesError === null || templatesError === void 0 ? void 0 : templatesError.message);
    }, [templatesError]);
    const handleMagicButtonTemplateSelection = (_event, item) => {
        //@ts-ignore
        form.setFieldValue(field.name, item);
    };
    const options = useMemo(() => {
        if (!(templates === null || templates === void 0 ? void 0 : templates.data))
            return [];
        const groupedTemplates = groupByVendorName(templates.data);
        return Object.entries(groupedTemplates)
            .filter(([vendorName]) => !searchKey || vendorName.match(new RegExp(searchKey, "i")))
            .map(([vendorName, templates]) => ({
            id: vendorName,
            name: vendorName,
            templates,
        }));
    }, [templates === null || templates === void 0 ? void 0 : templates.data, searchKey]);
    return (React.createElement(PeekAutocomplete, { freeSolo: false, clearIcon: null, popupIcon: null, onChange: handleMagicButtonTemplateSelection, options: (options === null || options === void 0 ? void 0 : options.length) ? options : [], getOptionLabel: ({ name }) => name, sx: { ".MuiAutocomplete-input": { pl: "4px !important" } }, value: options.find((option) => { var _a; return option.id === ((_a = field.value) === null || _a === void 0 ? void 0 : _a.id); }), isOptionEqualToValue: (option, value) => option.id === (value === null || value === void 0 ? void 0 : value.id), renderInput: (params) => (React.createElement(PeekInput, Object.assign({ field: Object.assign(Object.assign({}, field), { value: searchKey, onChange: (e) => setSearchKey(e.target.value) }), form: form }, params, props, { InputLabelProps: { required: true }, InputProps: Object.assign({}, params.InputProps) }))) }));
}
